module.exports = __webpack_public_path__ + "static/media/vine-social-media-svgrepo-com.0081c68e.svg";